<template>
  <v-card class="pb-5">
    <v-layout s justify-center>
        <v-flex lg12>
          <v-layout class="mt-4" justify-center>
            <b class="primary--text checkout-h2 font-weight-bold"
              >Este evento está em Pré-Venda!</b
            >
          </v-layout>
          <v-layout :class="$vuetify.breakpoint.mdAndUp ? '' : 'px-4'" class="mt-2 accent--text" justify-center>
            Insira abaixo seu código especial de pré-venda para iniciar a compra:
          </v-layout>
          <v-layout class="mt-4" row justify-center>
            <v-text-field
              background-color="white"
              style="
                max-width: 270px;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
              "
              outline
              label="Código"
              v-model="coupon"
              @keydown.enter="getProducts"
            ></v-text-field>
            <v-btn
              height="58"
              style="border-top-left-radius: 0; border-bottom-left-radius: 0; height: 58px !important; margin-top: 0px; margin-left: -2px; max-width: 40px !important;"
              depressed
              width="40"
              color="primary"
              @click="getProducts"
              ><v-icon>las la-check</v-icon></v-btn
            >
          </v-layout>
        </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      coupon: "",
    };
  },
  methods: {
    async getProducts() {
      await this.$store.dispatch('setCupomCode', this.coupon)
      await this.$store.dispatch('setSectorsList');
    },
  },
};
</script>
